import { render } from "./BootstrapCollapse.vue?vue&type=template&id=434acffc"
import script from "./BootstrapCollapse.vue?vue&type=script&lang=js"
export * from "./BootstrapCollapse.vue?vue&type=script&lang=js"

import exportComponent from "../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__